import { render, staticRenderFns } from "./ModalCommon.vue?vue&type=template&id=bb840a0e&scoped=true&"
import script from "./ModalCommon.vue?vue&type=script&lang=js&"
export * from "./ModalCommon.vue?vue&type=script&lang=js&"
import style0 from "./ModalCommon.vue?vue&type=style&index=0&id=bb840a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb840a0e",
  null
  
)

export default component.exports